@if (showHeader) {
    <app-header></app-header>
}

<app-chat-bubble></app-chat-bubble>
<router-outlet></router-outlet>

@if (!isServer) {
    <app-footer></app-footer>
}
